import { AddressSuggestionForUser } from 'shared/types/user_address';

import { ADDRESS_MAPPINGS } from '../constants/usps_constants';

// maps USPS response to match our fields mapping
function getAddressDiff(diff: Record<string, string>) {
  const suggestedAddress: Record<any, string> = {};
  if (diff && Object.keys(diff).length > 0) {
    for (const [key, value] of Object.entries(diff)) {
      if (ADDRESS_MAPPINGS[key]) {
        suggestedAddress[ADDRESS_MAPPINGS[key]] = value;
      }
    }
  }
  return suggestedAddress;
}

export function getAddressSuggestionData(userData: any, uspsAddressDiff: any) {
  const suggestedAddressChanges = getAddressDiff(uspsAddressDiff);
  const userAddressSuggestion: AddressSuggestionForUser = {
    address_state: {
      value: userData.address_state,
      changed: false
    },
    address_city: {
      value: userData.address_city,
      changed: false
    },
    street_address: {
      value: userData.street_address,
      changed: false
    },
    postal_code: {
      value: userData.postal_code,
      changed: false
    }
  };

  for (const [key, value] of Object.entries(suggestedAddressChanges)) {
    if (key !== 'zip4' && key !== 'zip5') {
      // @ts-ignore
      userAddressSuggestion[key] = {
        value: value,
        changed: true
      };
    }
  }
  if (suggestedAddressChanges.zip4 || suggestedAddressChanges.zip5) {
    const currentZipCodeParts = userData.postal_code?.split('-') || [];
    const zip5 = suggestedAddressChanges.zip5 || currentZipCodeParts[0];
    const zip4 = suggestedAddressChanges.zip4 || currentZipCodeParts[1];
    const combinedZipToSuggest = zip4 ? `${zip5}-${zip4}` : zip5;
    userAddressSuggestion['postal_code'] = {
      value: combinedZipToSuggest,
      changed: true
    };
  }
  return userAddressSuggestion;
}
